import React from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Tooltip,
  Link,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import DataTable from "./DataTable";
import { styles } from "./DataTable.styles";
import {
  FaInstagram,
  FaYoutube,
  FaFacebook,
  FaLinkedin,
  FaTiktok,
  FaSnapchat,
} from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";

const SocialMediaUserNameAvailability = ({
  brandNameScoresData,
  expandAccordian,
  onAccordionChange,
  isMobile,
  flipColumns,
}) => {
  const socialMediaColumns = [
    {
      id: "name",
      label: "Brand Name",
      width: "25%",
    },
    {
      id: "userNames",
      label: "User Names",
      width: "25%",
      format: (value) => "",
    },
    {
      id: "instagram",
      label: (
        <Tooltip title="Instagram">
          <Link
            href="https://instagram.com"
            target="_blank"
            rel="noopener noreferrer"
            sx={{ color: "inherit" }}
          >
            <FaInstagram />
          </Link>
        </Tooltip>
      ),
      width: "8%",
      format: (value) => "",
    },
    {
      id: "youtube",
      label: (
        <Tooltip title="YouTube">
          <Link
            href="https://youtube.com"
            target="_blank"
            rel="noopener noreferrer"
            sx={{ color: "inherit" }}
          >
            <FaYoutube />
          </Link>
        </Tooltip>
      ),
      width: "8%",
      format: (value) => "",
    },
    {
      id: "facebook",
      label: (
        <Tooltip title="Facebook">
          <Link
            href="https://facebook.com"
            target="_blank"
            rel="noopener noreferrer"
            sx={{ color: "inherit" }}
          >
            <FaFacebook />
          </Link>
        </Tooltip>
      ),
      width: "8%",
      format: (value) => "",
    },
    {
      id: "linkedin",
      label: (
        <Tooltip title="LinkedIn">
          <Link
            href="https://linkedin.com"
            target="_blank"
            rel="noopener noreferrer"
            sx={{ color: "inherit" }}
          >
            <FaLinkedin />
          </Link>
        </Tooltip>
      ),
      width: "8%",
      format: (value) => "",
    },
    {
      id: "x",
      label: (
        <Tooltip title="X">
          <Link
            href="https://x.com"
            target="_blank"
            rel="noopener noreferrer"
            sx={{ color: "inherit" }}
          >
            <FaXTwitter />
          </Link>
        </Tooltip>
      ),
      width: "8%",
      format: (value) => "",
    },
    {
      id: "tiktok",
      label: (
        <Tooltip title="TikTok">
          <Link
            href="https://tiktok.com"
            target="_blank"
            rel="noopener noreferrer"
            sx={{ color: "inherit" }}
          >
            <FaTiktok />
          </Link>
        </Tooltip>
      ),
      width: "8%",
      format: (value) => "",
    },
    {
      id: "snapchat",
      label: (
        <Tooltip title="Snapchat">
          <Link
            href="https://snapchat.com"
            target="_blank"
            rel="noopener noreferrer"
            sx={{ color: "inherit" }}
          >
            <FaSnapchat />
          </Link>
        </Tooltip>
      ),
      width: "8%",
      format: (value) => "",
    },
  ];

  return (
    <Accordion
      expanded={expandAccordian}
      onChange={onAccordionChange}
      sx={styles.accordion}
    >
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography variant="h6" sx={styles.accordionTitle}>
          Social Media User Name Availability
        </Typography>
      </AccordionSummary>
      <AccordionDetails>
        <DataTable
          columns={socialMediaColumns}
          data={brandNameScoresData}
          isReportData={false}
          sx={styles.dataTable}
          isMobile={isMobile}
          flipColumns={flipColumns}
        />
      </AccordionDetails>
    </Accordion>
  );
};

export default SocialMediaUserNameAvailability;
